import React from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import "./About.css";
import Contact from "../Components/Contact";

const About = () => {
  document.title = "About - Rizatzmi";

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <section className="About-Section">
        <h1 className="About-Title">ABOUT</h1>
        <div className="About-Wrapper">
          <img src="/Assets/About.png" alt="" className="About-Image" />
          <div className="About-Content">
            <h1 className="About-Name">
              Hello I'm<br></br>
              <span style={{ color: "#d9c57a" }}>Rizqi Shoqibul Atzmi</span>
            </h1>
            <p className="About-Description">
              As someone who is still a junior in all his positions, I still
              have a ton of skills to offer. As a UI/UX Designer, I have skills
              in User Interface Design, User Experience Design, Wireframing and
              Prototyping. As a Wordrpess Developer I also have a wealth of
              impressive skill using page builders such as Elementor. Finally,
              as a Front-End Developer I have skills in HTML, CSS, JavaScript,
              React and Tailwind. My expertise lies in crafting dynamic,
              engaging interfaces through writing clean and optimized code and
              utilizing cutting-edge development tools and techniques. I am also
              a team player who thrives in collaborating with cross-functional
              teams to produce outstanding web applications.
            </p>
          </div>
        </div>
      </section>
      <section className="Contact-Section">
        <Contact />
      </section>
      <Footer />
    </>
  );
};

export default About;
